function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import memoize from 'memoize-one';
import { ContextActions, createXComponent } from '@deephaven/components';
import { copyToClipboard, EMPTY_ARRAY } from '@deephaven/utils';
import Panel from "./CorePanel.js";
import WidgetPanelTooltip from "./WidgetPanelTooltip.js";
import "./WidgetPanel.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Widget panel component that has a loading spinner and displays an error message when set
 */
class WidgetPanel extends PureComponent {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "getCachedRenderTabTooltip", memoize((showTabTooltip, descriptor) => showTabTooltip ? () => /*#__PURE__*/_jsx(WidgetPanelTooltip, {
      descriptor: descriptor
    }) : undefined));
    _defineProperty(this, "getCachedActions", memoize(function (descriptor) {
      var _descriptor$displayTy;
      var propsAdditionalActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
      return [...propsAdditionalActions, {
        title: "Copy ".concat((_descriptor$displayTy = descriptor.displayType) !== null && _descriptor$displayTy !== void 0 ? _descriptor$displayTy : descriptor.type, " Name"),
        group: ContextActions.groups.medium,
        order: 20,
        action: _this.handleCopyName
      }];
    }));
    this.handleSessionClosed = this.handleSessionClosed.bind(this);
    this.handleCopyName = this.handleCopyName.bind(this);
    this.state = {
      isClientDisconnected: false,
      isPanelDisconnected: false,
      isWidgetDisconnected: false,
      isWaitingForReconnect: false,
      isPanelInactive: false
    };
  }
  handleCopyName() {
    var descriptor = this.props.descriptor;
    copyToClipboard(descriptor.name);
  }
  getErrorMessage() {
    var _this$props = this.props,
      descriptor = _this$props.descriptor,
      errorMessage = _this$props.errorMessage;
    var _this$state = this.state,
      isClientDisconnected = _this$state.isClientDisconnected,
      isPanelDisconnected = _this$state.isPanelDisconnected,
      isWidgetDisconnected = _this$state.isWidgetDisconnected,
      isWaitingForReconnect = _this$state.isWaitingForReconnect;
    if (errorMessage != null && errorMessage !== '') {
      return "".concat(errorMessage);
    }
    if (isClientDisconnected && isPanelDisconnected && isWaitingForReconnect) {
      return 'Disconnected from server.\nCheck your internet connection.';
    }
    if (isClientDisconnected && isPanelDisconnected) {
      return 'Disconnected from server.';
    }
    if (isPanelDisconnected) {
      var name = descriptor.name,
        type = descriptor.type;
      return "Variable \"".concat(name, "\" not set.\n").concat(type, " does not exist yet.");
    }
    if (isWidgetDisconnected) {
      return "".concat(descriptor.name, " is unavailable.");
    }
    return undefined;
  }
  handleSessionClosed(session) {
    var onSessionClose = this.props.onSessionClose;
    // The session has closed and we won't be able to reconnect, as this widget isn't persisted
    this.setState({
      isPanelDisconnected: true,
      isWaitingForReconnect: false
    });
    onSessionClose === null || onSessionClose === void 0 || onSessionClose(session);
  }
  render() {
    var _this$props2 = this.props,
      children = _this$props2.children,
      className = _this$props2.className,
      componentPanel = _this$props2.componentPanel,
      descriptor = _this$props2.descriptor,
      isLoaded = _this$props2.isLoaded,
      isLoading = _this$props2.isLoading,
      glContainer = _this$props2.glContainer,
      glEventHub = _this$props2.glEventHub,
      isDisconnected = _this$props2.isDisconnected,
      isClonable = _this$props2.isClonable,
      isRenamable = _this$props2.isRenamable,
      _this$props2$showTabT = _this$props2.showTabTooltip,
      showTabTooltip = _this$props2$showTabT === void 0 ? false : _this$props2$showTabT,
      renderTabTooltip = _this$props2.renderTabTooltip,
      onClearAllFilters = _this$props2.onClearAllFilters,
      onErrorAction = _this$props2.onErrorAction,
      onHide = _this$props2.onHide,
      onFocus = _this$props2.onFocus,
      onBlur = _this$props2.onBlur,
      onResize = _this$props2.onResize,
      onSessionOpen = _this$props2.onSessionOpen,
      onShow = _this$props2.onShow,
      onTabBlur = _this$props2.onTabBlur,
      onTabFocus = _this$props2.onTabFocus,
      onTabClicked = _this$props2.onTabClicked,
      propsAdditionalActions = _this$props2.additionalActions;
    var _this$state2 = this.state,
      isPanelDisconnected = _this$state2.isPanelDisconnected,
      isWidgetDisconnected = _this$state2.isWidgetDisconnected,
      isPanelInactive = _this$state2.isPanelInactive;
    var errorMessage = this.getErrorMessage();
    var doRenderTabTooltip = renderTabTooltip !== null && renderTabTooltip !== void 0 ? renderTabTooltip : this.getCachedRenderTabTooltip(showTabTooltip, descriptor);
    var additionalActions = this.getCachedActions(descriptor, propsAdditionalActions);
    return /*#__PURE__*/_jsxs(Panel, {
      className: classNames(className, {
        disconnected: isPanelDisconnected || isWidgetDisconnected || isDisconnected,
        inactive: isPanelInactive
      }),
      componentPanel: componentPanel,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onClearAllFilters: onClearAllFilters,
      onErrorAction: onErrorAction,
      onHide: onHide,
      onFocus: onFocus,
      onBlur: onBlur,
      onResize: onResize,
      onShow: onShow,
      onSessionClose: this.handleSessionClosed,
      onSessionOpen: onSessionOpen,
      onTabBlur: onTabBlur,
      onTabFocus: onTabFocus,
      onTabClicked: onTabClicked,
      renderTabTooltip: doRenderTabTooltip,
      errorMessage: errorMessage,
      isLoaded: isLoaded,
      isLoading: isLoading,
      isClonable: isClonable,
      isRenamable: isRenamable,
      additionalActions: additionalActions,
      children: [children, isPanelInactive && /*#__PURE__*/_jsx("div", {
        className: "fill-parent-absolute"
      })]
    });
  }
}
_defineProperty(WidgetPanel, "defaultProps", {
  className: '',
  isClonable: true,
  isDisconnected: false,
  isLoading: false,
  isLoaded: true,
  isRenamable: true,
  showTabTooltip: true
});
var XWidgetPanel = createXComponent(WidgetPanel);
export default XWidgetPanel;
//# sourceMappingURL=WidgetPanel.js.map